import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import App from './App';

let r = ReactDOM.render(
  <App
    properties = {window.efcRegistrationWidget.properties}
  />,
  document.getElementById('efcRegistrationWidget')
);

window.efcRegistrationWidget.open = r.open.bind(r);
